module.exports = __webpack_public_path__ + "img/map-pointer.0f36819a.svg";